export const SUBSCRIPTIONS_DOMAIN = 'subscriptions'
export const SUBSCRIPTIONS_ACTION = {
  LOAD_CURRENT: 'SUBSCRIPTIONS_LOAD_CURRENT',
  UPDATE_SOURCE: 'SUBSCRIPTIONS_UPDATE_SOURCE'
}

export const SUBSCRIPTIONS_ENDPOINT = {
  GET_SUBSCRIPTIONS_BY_ID: '/users/:id/subscriptions'

}

export const SUBSCRIPTIONS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

export const SUBSCRIPTIONS_PATH = {
  ALL: `${SUBSCRIPTIONS_DOMAIN}.${SUBSCRIPTIONS_KEY.ALL}`,
  CURRENT: `${SUBSCRIPTIONS_DOMAIN}.${SUBSCRIPTIONS_KEY.CURRENT}`,
  DATA: `${SUBSCRIPTIONS_DOMAIN}.${SUBSCRIPTIONS_KEY.DATA}`
}

export const SUBSCRIPTIONS_STATE = {
  [SUBSCRIPTIONS_KEY.ALL]: {
    data: [],
    status: null
  },
  [SUBSCRIPTIONS_KEY.CURRENT]: null,
  [SUBSCRIPTIONS_KEY.DATA]: {}
}

export const SUBSCRIPTION_CLASS_NAME = 'Subscription'

export const FREE_TRIAL_DAYS_COUNT = 7
